module.exports = __webpack_public_path__ + "static/img/1-3.8f0c1a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/images/1-3.png
// module id = 946
// module chunks = 30